export default __webpack_public_path__ + "static/media/substitute.12d45110.png";